var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9263 3.57379H4.07381C3.76657 3.57379 3.47191 3.69584 3.25465 3.9131C3.0374 4.13035 2.91534 4.42501 2.91534 4.73226C2.91534 5.0395 3.0374 5.33417 3.25465 5.55142C3.47191 5.76868 3.76657 5.89073 4.07381 5.89073H24.9263C25.2335 5.89073 25.5282 5.76868 25.7454 5.55142C25.9627 5.33417 26.0847 5.0395 26.0847 4.73226C26.0847 4.42501 25.9627 4.13035 25.7454 3.9131C25.5282 3.69584 25.2335 3.57379 24.9263 3.57379Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0847 14C26.0847 13.6928 25.9627 13.3981 25.7454 13.1808C25.5282 12.9636 25.2335 12.8415 24.9263 12.8415H4.07381C3.76657 12.8415 3.47191 12.9636 3.25465 13.1808C3.0374 13.3981 2.91534 13.6928 2.91534 14C2.91534 14.3072 3.0374 14.6019 3.25465 14.8192C3.47191 15.0364 3.76657 15.1585 4.07381 15.1585H24.9263C25.2335 15.1585 25.5282 15.0364 25.7454 14.8192C25.9627 14.6019 26.0847 14.3072 26.0847 14Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 22.1093H4.07381C3.76657 22.1093 3.47191 22.2313 3.25465 22.4486C3.0374 22.6658 2.91534 22.9605 2.91534 23.2678C2.91534 23.575 3.0374 23.8697 3.25465 24.0869C3.47191 24.3042 3.76657 24.4262 4.07381 24.4262H14.5C14.8073 24.4262 15.1019 24.3042 15.3192 24.0869C15.5364 23.8697 15.6585 23.575 15.6585 23.2678C15.6585 22.9605 15.5364 22.6658 15.3192 22.4486C15.1019 22.2313 14.8073 22.1093 14.5 22.1093Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuWhite);
export default __webpack_public_path__ + "static/media/menu-white.cea91fa0034b63797ac77a0e1e13fa43.svg";
export { ForwardRef as ReactComponent };